export default {
  data() {
    return {
      tourCommissionPercentage: null,
      takeCheckConfig: {},
      updating: false
    }
  },
  methods: {
    setTourAsWaiting(tour, silent = false) {
      if (!silent) {
        if (
          confirm(this.$gettext('Are you sure you want to set this tour as WAITING?'))
        ) {
          this.$http.post(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/waiting')
            .then(response => {
              if (typeof this.getTour === 'function') {
                this.getTour()
                this.$refs.modalModifyTourCommission.hide()
              } else {
                setTimeout(() => {
                  this.$root.$emit('bv::refresh::table', 'my-table')
                }, 200)
              }
            })
        }
      } else {
        this.$http.post(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/waiting')
          .then(response => {
            if (typeof this.getTour === 'function') {
              this.getTour()
              this.$refs.modalModifyTourCommission.hide()
            } else {
              setTimeout(() => {
                this.$root.$emit('bv::refresh::table', 'my-table')
              }, 200)
            }
          })
      }
    },
    formatNumber(number) {
      return (Math.round(((parseFloat(number)) + Number.EPSILON) * 100) / 100).toFixed(2)
    },
    priceByKm(tour) {
      const currency = window.countries.find(x => x.iso_code === tour.country_iso_code).currency
      const priceByKm = this.formatNumber((parseFloat(tour.commission / tour.total_distance)))

      if (tour.commission && tour.total_distance) {
        return `<span style="white-space: nowrap">${priceByKm} ${currency}/km.</span><br>`
      }
    },
    getTake(price, commission) {
      return this.formatNumber(((parseFloat(price) - parseFloat(commission)) * 100 / parseFloat(price)))
    },
    sanityDetail(tour) {
      const currency = window.countries.find(x => x.iso_code === tour.country_iso_code).currency

      const courierProfit = this.formatNumber(tour.commission)

      const clientCost = this.formatNumber(tour.price)

      const ourProfit = this.formatNumber((parseFloat(tour.price) - parseFloat(tour.commission)))

      const take = this.getTake(tour.price, tour.commission)

      let html = ''
      if (tour.fixed_amount_price_schedules.length === 0) {
        html += `<span style="white-space: nowrap">${this.$gettextInterpolate(this.$gettext('Courier profit: %{data}'), {data: courierProfit + ' ' + currency})}</span><br>`
      }
      html += `
      <span style="white-space: nowrap">${this.$gettextInterpolate(this.$gettext('Client cost: %{data}'), {data: clientCost + ' ' + currency})}</span><br>
      <span class="${take >= 30 ? 'text-success' : (take < 30 && take > 0 ? 'text-warning' : 'text-danger')}">
      ${this.$gettextInterpolate(this.$gettext('Our profit: %{data}'), {data: ourProfit + ' ' + currency})}
      </span><br>
      <span class="${take >= 30 ? 'text-success' : (take < 30 && take > 0 ? 'text-warning' : 'text-danger')}">
      ${this.$gettextInterpolate(this.$gettext('Take: %{data}'), {data: take + '%'})}
      </span><br>`
      html += this.priceByKm(tour) // + <span style="white-space: nowrap">${currency}/km.: ${priceByKm} ${currency}/km.</span><br>

      return html
    },
    async takeCheck(type, tour = null) {
      this.takeCheckConfig = {}
      if (!tour) {
        tour = this.tour
      }

      let tourRegionId

      const tourCountryTakeCheckConfig = window.countries.find(x => x.iso_code === tour.country_iso_code).front_config.takeCheckConfig

      if (tourCountryTakeCheckConfig) {
        if (!tour.shippings) {
          tour.shippings = await this.getTourShippings(tour)
        }
        tourRegionId = tour.shippings[0].to_area.regions.length > 0 ? tour.shippings[0].to_area.regions[0].id : null
        this.takeCheckConfig = tourCountryTakeCheckConfig.find(x => x.region_id === tourRegionId)
      }

      if (this.takeCheckConfig && this.takeCheckConfig.region_id) {
        let shippingsCount = tour.shippings.length

        if (this.takeCheckConfig.tour_quantity_check && (shippingsCount < this.takeCheckConfig.tour_min_quantity || shippingsCount > this.takeCheckConfig.tour_max_quantity)) {
          let goOnButtonText = type === 'assign' ? this.$gettext('Assignate it anyway') : this.$gettext('Set as WAITING anyway')
          let obj = {
            title: this.$gettext('Shipping Quantity Alert'),
            message: this.$gettextInterpolate(
              this.$gettext('This tour has %{count} shippings and it DOES NOT match the recommended shippings quantity which is between %{min} and %{max}'),
              {
                count: shippingsCount,
                min: this.takeCheckConfig.tour_min_quantity,
                max: this.takeCheckConfig.tour_max_quantity
              }
            ),
            type: 'warning',
            useConfirmBtn: true,
            customConfirmBtnText: goOnButtonText,
            onConfirm: () => {
              this.takeCheckCommission(type, tour)
            }
          }
          this.$parent.$refs.simplert.openSimplert(obj)
        } else {
          this.takeCheckCommission(type, tour)
        }
      } else {
        if (type === 'assign') {
          this.$refs.modalAssignNormal.show()
        } else if (type === 'waiting') {
          this.setTourAsWaiting(tour)
        }
      }
    },
    takeCheckCommission(type, tour = null) {
      if (!tour) {
        tour = this.tour
      }
      if (this.takeCheckConfig['tour_' + type + '_check']) {
        const tourData = this.takeCheckCurrentData(tour)
        if (this.takeCheckConfig.tour_auto_apply_if_positive === true && tourData.takeDiff > 0 &&
          this.takeCheckConfig.tour_quantity_check &&
          ((!this.takeCheckConfig.tour_dont_check_max_quantity_on_auto_apply && tour.shippings.length >= this.takeCheckConfig.tour_min_quantity && tour.shippings.length <= this.takeCheckConfig.tour_max_quantity) ||
          (this.takeCheckConfig.tour_dont_check_max_quantity_on_auto_apply && tour.shippings.length >= this.takeCheckConfig.tour_min_quantity))
        ) {
          this.updating = true
          this.fixCommissions(type, tourData.optimalPercent, tour)
        } else if (
          tourData.takeDiff !== 0 &&
          (this.takeCheckConfig.tour_allow_negative_impact === true || (this.takeCheckConfig.tour_allow_negative_impact === false && tourData.takeDiff > 0))
        ) {
          let fixItButtonText = type === 'assign' ? this.$gettext('FIX IT and assign') : this.$gettext('FIX IT and set as WAITING')
          let goOnNormallyButtonText = type === 'assign' ? this.$gettext('Assign it AS IS') : this.$gettext('Set as WAITING AS IS')

          let mssg = ''
          if (tourData.optimalCommission > tourData.price) {
            mssg += '<p class="text-danger"><strong>' + this.$gettext('WARNING: THE OPTIMAL TOUR COMMISSION IS HIGHER THAN THE CLIENT COST!!!') + '</strong></p>'
          }
          mssg += '<p>' + this.$gettextInterpolate(this.$gettext('Current commission: <strong>%{commission}</strong>'), {commission: this.formatNumber(tourData.commission)}) + '<br>'
          mssg += this.$gettextInterpolate(this.$gettext('Optimal tour commission: <strong>%{optimalCommission}</strong>'), {optimalCommission: this.formatNumber(tourData.optimalCommission)}) + '<br>'
          mssg += this.$gettextInterpolate(this.$gettext('Current take: <strong>%{take}%</strong>'), {take: this.formatNumber(tourData.take)}) + '<br>'
          mssg += this.$gettextInterpolate(this.$gettext('Optimal tour take: <strong>%{optimalTake}%</strong>'), {optimalTake: this.formatNumber(tourData.optimalTake)}) + '</p>'
          mssg += '<p class="' + (tourData.takeDiff < 0 ? 'text-danger' : 'text-success') + '">' + this.$gettextInterpolate(
            this.$gettext('Fixing this tour would make our take <strong>%{betterWorse}</strong> by %{takeDiff}%'),
            {
              betterWorse: tourData.takeDiff < 0 ? this.$gettext('worse') : this.$gettext('better'),
              takeDiff: this.formatNumber(tourData.takeDiff)
            }
          ) + '</p>'
          let obj = {
            title: this.$gettext('Commission Alert'),
            message: mssg,
            type: 'warning',
            useConfirmBtn: true,
            customConfirmBtnText: fixItButtonText,
            customConfirmBtnClass: 'btn btn-primary btn-block',
            onConfirm: () => {
              this.updating = true
              this.fixCommissions(type, tourData.optimalPercent, tour)
            },
            customCloseBtnText: goOnNormallyButtonText,
            customCloseBtnClass: 'btn btn-secondary btn-block',
            onClose: () => {
              if (type === 'assign') {
                this.$refs.modalAssignNormal.show()
              } else if (type === 'waiting') {
                this.setTourAsWaiting(tour, true)
              }
            }
          }
          this.$parent.$refs.simplert.openSimplert(obj)
        } else {
          if (type === 'assign') {
            this.$refs.modalAssignNormal.show()
          } else if (type === 'waiting') {
            this.setTourAsWaiting(tour)
          }
        }
      } else {
        if (type === 'assign') {
          this.$refs.modalAssignNormal.show()
        } else if (type === 'waiting') {
          this.setTourAsWaiting(tour)
        }
      }
    },
    async fixCommissions(type, optimalPercent, tour = null) {
      if (!tour) {
        tour = this.tour
      }
      if (optimalPercent >= -100) {
        this.tourCommissionPercentage = optimalPercent
        await this.modifyTourCommission(true, tour)
          .then(() => {
            if (type === 'assign') {
              this.$refs.modalAssignNormal.show()
            } else if (type === 'waiting') {
              this.setTourAsWaiting(tour, true)
            }
          })
          .finally(() => {
            this.tourCommissionPercentage = null
            this.updating = false
          })
      }
    },
    takeCheckCurrentData(tour) {
      let price = tour.price
      let commission = tour.commission
      let shippingsCount = tour.shippings.length
      let tourDistance = tour.total_distance
      let take = this.getTake(price, commission)

      let optimalCommissionKm = this.takeCheckConfig.tour_min_price_km * tourDistance
      let optimalCommissionShipping = this.takeCheckConfig.tour_min_price * shippingsCount
      let optimalCommission = Math.max(optimalCommissionKm, optimalCommissionShipping)
      let optimalTake = this.getTake(price, optimalCommission)
      let optimalPercent = -(100 - optimalCommission * 100 / commission)
      let takeDiff = optimalTake - take
      return {
        price,
        commission,
        shippingsCount,
        tourDistance,
        take,
        optimalCommission,
        optimalTake,
        optimalPercent,
        takeDiff
      }
    },
    async getTourShippings(tour) {
      const params = {
        includes: [
          'shippings.to_area.regions'
        ]
      }
      return await this.$http.get(this.$appConfig.api.baseUrl + 'tours/' + tour.id, {params: params})
        .then(response => {
          return response.body.shippings
        })
    },
    async modifyTourCommission(silent = false, tour = null) {
      if (!tour) {
        tour = this.tour
      }
      if (!silent) {
        if (
          confirm(this.$gettext('Are you sure you want to MODIFY the total Tour Commission by your set percentage?'))
        ) {
          return await this.$http.put(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/commission', { percentage: this.tourCommissionPercentage })
            .then(response => {
              if (typeof this.getTour === 'function') {
                this.getTour()
                this.$refs.modalModifyTourCommission.hide()
              } else {
                this.refreshTable()
              }
            })
        }
      } else {
        return await this.$http.put(this.$appConfig.api.baseUrl + 'tours/' + tour.id + '/commission', { percentage: this.tourCommissionPercentage })
          .then(response => {
            if (typeof this.getTour === 'function') {
              this.getTour()
              this.$refs.modalModifyTourCommission.hide()
            }
          })
      }
    }
  }
}
